import { render, staticRenderFns } from "./MDetailStore.vue?vue&type=template&id=44132884&"
import script from "./MDetailStore.vue?vue&type=script&lang=js&"
export * from "./MDetailStore.vue?vue&type=script&lang=js&"
import style0 from "./MDetailStore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports